import script from "./UnmappedCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./UnmappedCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./UnmappedCampaigns.vue?vue&type=style&index=0&id=08e8fe02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e8fe02"]])

export default __exports__